 
<section class="jumbotron text-center my-4">
  <div class="container1" style="width:100%;background:#000">
    <div class="container" style="width:70%;background:#000">
      <img src="./assets/img/backing_mh.jpg" class="w-100"/>
    </div>
  </div>
  <div class="container2">
    <div class="container2">
      <h5 class="jumbotron-heading style2 section1" style="margin:7px 0px"><b>DESCRIPCIÓN</b></h5>
    </div>
  </div>
</section>

<section class="jumbotron text-center my-4 section122">
    <div class="container2">  
      <section class="jumbotron text-center my-2 style3">
        <div  class="py-2 team4">
          <div  class="container">
            <div class="row justify-content-center">
              <div class="col-lg-5 mb-4">
                <div class="card">
                  <div class="row text-center">
                    <div class="card-body" style="margin:15px;text-align: justify">
                      El acercamiento a la poética de Miguel Hernández y la repercusión internacional de su patrimonio literario es reconocido a través de las distintas actividades que se realizan en torno a su legado. Estos procesos de difusión, en la actualidad, se han incrementado gracias a la exploración de los nuevos medios tecnológicos y el desarrollo de innovadoras plataformas virtuales 3D, a través de los cuales, además de compartir desde distintas partes del mundo el patrimonio inmaterial de una nación, también sirven como fuente para generar conexiones profesionales y de investigación. 
                      La exposición virtual titulada “Desde Loja, Ecuador: homenaje a Miguel Hernández”, es posible gracias a un convenio de colaboración entre la Universidad Técnica Particular de Loja (UTPL), la Dirección de Industrias Culturales Alejandro Rommers de la
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-5 mb-4">
                <div class="card">
                  <div class="row text-center">
                    <div class="card-body" style="margin:15px;text-align: justify">
                      Universidad Miguel Hernández, España; 
                      BiCoa Base Intercultural Comunidad de Las Américas, New York; Université Paris Nanterre, Francia; Fundación cultural Miguel Hernández, España; Adelphi University, New York y la Fundación Fidal y Raw: The Glocal Woman Foundation, Ecuador. Contempla las siguientes fases: 
                      <br/><br/><b>Parte I:</b> Infancia del poeta en Orihuela; 
                      <br/><b>Parte II:</b> La relación con los intelectuales de su tiempo; 
                      <br/><b>Parte III:</b> Su paso por la cárcel; 
                      <br/><b>Parte IV:</b> Antología Iberoamericana;
                      <br/><b>Parte V:</b> Poesía de Miguel Hernández musicalizada.<br/><br/><br/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
</section>

<section class="jumbotron text-center my-4">
  <div class="container2">
    <div class="container2">
      <h5 class="jumbotron-heading style2 section1" style="margin:7px 0px"><b>CAPTURAS DE LA EXPOSICIÓN FOTOGRÁFICA</b></h5>
    </div>
  </div>
</section>

<section class="jumbotron text-center my-4 section1">
  <div class="row background1" >
    <div class="padding1">
      <section>
        <section class="padding3">
          <div class="row" >
            <div class="col-lg-4 col-md-12 mb-4 mb-lg-0">
              <div
                class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
                <img src="./assets/img/1.jpg" class="w-100"/>
                <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal1">
                  <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                </a>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
                <img src="./assets/img/2.jpg" class="w-100"/>
                <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal2">
                  <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                </a>
              </div>
            </div>
            <div class="col-lg-4 mb-4 mb-lg-0">
              <div class="bg-image hover-overlay ripple shadow-1-strong rounded" data-ripple-color="light">
                <img src="./assets/img/3.jpg" class="w-100"/>
                <a href="#!" data-mdb-toggle="modal" data-mdb-target="#exampleModal3">
                  <div class="mask" style="background-color: rgba(251, 251, 251, 0.2);"></div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  </div> 
</section>

<section class="jumbotron text-center my-4">
  <div class="container  mt-4" class="style2">
    <div>
      <div class="row">
        <div class="col-12 text-center">
          <div class="section-title mb-4 pb-2">
            <h1 class="jumbotron-heading">¡Disfruta de esta extraordinaria experiencia!</h1>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!--
      <button mat-raised-button class="btn btn-dark margin1" (click)="openBuild()">
        Práctica calificada (requiere credenciales UTPL)
      </button>&nbsp;&nbsp;
      <button mat-raised-button class="btn btn-dark margin1" (click)="openBuild_libre()">
        Acceder a la exposición virtual Miguel Hernández
      </button>
    -->
    <button mat-raised-button class="btn btn-dark margin1" (click)="openBuild_libre()">
      Acceder a la exposición virtual Miguel Hernández
    </button>
    </div>
  </div>
</section>  
<section class="jumbotron text-center my-2 style3">
  <div class="container  mt-4">
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h1 class="jumbotron-heading"><span class="style4"> Equipo docente</span></h1>
        </div>
      </div>
    </div>
  </div>
  <div  class="py-2 team4">
    <div  class="container2">
      <div class="row justify-content-center">
        <div class="col-lg-2 mb-4">
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <img class="card-img-top"
                src="./assets/img/Martha_Vanessa_Agila_Palacios.jpg"
                alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">MARTHA VANESSA AGILA PALACIOS</h5><hr />
                <h6>Docente investigador UTPL</h6><br/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 mb-4">
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <img class="card-img-top" 
                src="./assets/img/Claudia_Paola_Cartuche_Flores.jpg"
                  alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">CLAUDIA PAOLA CARTUCHE FLORES</h5><hr />
                <h6>Docente investigador UTPL</h6><br/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 mb-4">
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <img class="card-img-top"
                src="./assets/img/Ines_Monica_Sarmiento_Archer.jpg"
                alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">INÉS MÓNICA SARMIENTO ARCHER</h5><hr />
                <h6>Coordinadora, 4GCURHI - docente Adelphi</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 mb-4">
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <img class="card-img-top" 
                src="./assets/img/Norman_Alberto_Gonzalez_Tamayo.jpg"
                  alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">NORMAN ALBERTO GONZÁLEZ TAMAYO</h5><hr />
                <h6>Docente investigador UTPL</h6><br/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2 mb-4">
          <div class="card">
            <div class="row text-center">
              <div class="col-md-12">
                <img class="card-img-top" 
                src="./assets/img/SAMANIEGO_FRANCO_JENNIFER_BETZABE.jpeg"
                  alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">JENNIFER SAMANIEGO</h5><hr />
                <h6>COORDINACIÓN DEL PROYECTO</h6><br/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div  class="py-2 team4 background">
  <div class="width1">
    <div  class="row justify-content-center mb-4">
      <div  class="col-md-12 text-center">
        <h1  class="mb-4">Soporte tecnológico</h1>
          <h6>
            Trabajo conjunto entre el Club de Realidad Virtual y la Dirección de Tecnologías para la Educación.
          </h6>
      </div>
    </div>
    <div class="row justify-content-center" style="padding-left:3%">
      <div class="col-lg-2 mb-4">
        <div class="row text-center">
          <div class="col-md-10">
            <img src="./assets/img/Jonathan_Ramirez.jpg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Jhonatan Ramírez</h5>
              <h6  class="subtitle mb-3">DESARROLLO UNITY</h6>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-lg-2 mb-4">
        <div  class="row text-center">
          <div  class="col-md-10">
            <img src="./assets/img/Edgar_Martinez.jpeg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Edgar Martínez</h5>
              <h6  class="subtitle mb-3">DESARROLLO UNITY</h6>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-lg-2 mb-4">
        <div  class="row text-center">
          <div  class="col-md-10">
            <img src="./assets/img/Julio_Cesar_Luna.jpeg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Julio Luna</h5>
              <h6  class="subtitle mb-3">DESARROLLO UNITY</h6>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-lg-2 mb-4">
        <div  class="row text-center">
          <div  class="col-md-10">
            <img src="./assets/img/Juan_Jose_Yanangomez.jpeg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Juan José Yanangomez</h5>
              <h6  class="subtitle mb-3">DESARROLLO UNITY</h6>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-lg-2 mb-4">
        <div  class="row text-center">
          <div  class="col-md-10">
            <img src="./assets/img/Wimper_Tigrero.jpeg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Wimper Tigrero</h5>
              <h6  class="subtitle mb-3">DISEÑO 3D</h6>
            </div>
          </div>
        </div>
      </div>
      <div  class="col-lg-2 mb-4">
        <div  class="row text-center">
          <div  class="col-md-10">
            <img src="./assets/img/ROMERO_PARRA_ALEX_FERNANDO.jpg" alt="wrapkit" class="img-fluid rounded-circle">
          </div>
          <div  class="col-md-10 text-center">
            <div  class="pt-2">
              <h5  class="mt-4 font-weight-medium mb-0">Alex Romero</h5>
              <h6  class="subtitle mb-3">DESARROLLO ANGULAR</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<footer>
  <div class="text-center p-3">
    © 2022 Copyright:
    <a class="text-dark" href="https://utpl.edu.ec/" target="_blank" >UTPL</a>
  </div>
</footer>
  